import { render, staticRenderFns } from "./ControlManagement.vue?vue&type=template&id=bbf54fec&"
import script from "./ControlManagement.vue?vue&type=script&lang=js&"
export * from "./ControlManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports